<template>
  <div class="home">
    <Steps />
  </div>
</template>

<script>
import Steps from './step/index'
// @ is an alias to /src
export default {
  name: 'Home',
  components: {
    Steps
  },
  mounted () {
    this.$router.push({ name: 'Home', hash: '#step1', params: { index: 1 } })
  }
}
</script>
